let api = window.paramConfig.api;
let ipvideo = window.paramConfig.ipvideo;
let indexUrl = window.paramConfig.indexUrl;
let twoLevelUrl = window.paramConfig.twoLevel;
let publicKey = window.paramConfig.publicKey;
export default {
	ipIndex: indexUrl+"/wsppc/",
	ipvideo: ipvideo,
	ip: api,
	twoLevel: twoLevelUrl,
	//请求成功id
	okId: 0,
	//请求失败id
	errorId: 204,
	errorLoginId: 202,
	error203Id: 203,
	errorManuId: 400,
	errorFrenId: 403,
	publicKey: publicKey,
}